// Should really be called "normalizeFetchErrors" - you can't meaningfully throw
// exceptions from inside promise handlers, but I _GUESS_ that error
// normalization is the goal here.
export const throwFetchErrors = (response) => {
  return response?.text().then((resp) => {
    const data = JSON.parse(resp);
    if (data.resultCode === 'Refused') {
      // eslint-disable-next-line no-throw-literal
      throw {
        ...data,
        status: response.status,
        message: data.refusalReason,
      };
    }
    if (data.ok) {
      return response.json();
    }

    // eslint-disable-next-line no-throw-literal
    throw {
      ...data,
      status: response.status,
      message: data.message || `HTTP status code ${response.status}`,
    };
  });
};
